<template>
<div>
    <div class="row">
        <div class="col_12">
            <div class="card no_border">
                <div class="card-header">
                    <div class="card-title">{{ $t('common.chapter') }}</div>
                </div>
                <div class="card-body pl_0 pr_0">
                    <div class="row">
                        <div class="col_3">
                            <div class="form-group ">
                                <div class="d_flex_start">
                                    <div class="dropdown custom_dropdown mr_10">
                                        <button class="btn">
                                            <span> {{ filter.grade != '' && grades.length ? grades.find(s=> s.id === parseInt(filter.grade)).name : $t('common.grade') }}</span>
                                        </button>
                                        <div class="dropdown_menu">
                                            <ul>
                                                <li @click="gradeFilter(grade.id)" v-for="grade in grades" :key="'grade'+grade.id"><a role="button">{{ grade.name }}</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col_3">
                            <div class="form-group ">
                                <div class="d_flex_start">
                                    <div class="dropdown custom_dropdown mr_10">
                                        <button class="btn">
                                            <span> {{ filter.semester != '' && semesters.length ? semesters.find(s=> s.id === parseInt(filter.semester)).name : $t('common.semester') }}</span>
                                        </button>
                                        <div class="dropdown_menu">
                                            <ul>
                                                <li @click="semesterFilter(semester.id)" v-for="semester in semesters" :key="'semester'+semester.id"><a role="button">{{ semester.name }}</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col_6">
                            <div class="form-group ">
                                <div class="d_flex_end">
                                    <div class="form_row_inline">
                                        <input type="text" class="form_global" :placeholder="$t('common.search')" v-model="queryParams.search">
                                    </div>
                                    <div class="form_row_inline ml_10">
                                        <div class="btn btn_common_type_2 mr_10 width_150p" @click="searchQuery()">{{ $t('common.search') }}</div>
                                        <div class="btn btn_secondary width_150p" @click="resetAll()">{{ $t('common.reset') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col_12 ">
                            <div class="separator pl_0 pr_0">
                                <span></span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col_12">
                            <div class="d_flex_btwn pt_20 pb_20">
                                <div class="d_flex_start col_2 pl_0">
                                    <div class="dropdown custom_dropdown mr_10">
                                        <button class="btn">
                                            <span>{{ filter.per_page }}</span>
                                        </button>
                                        <div class="dropdown_menu">
                                            <ul>
                                                <li @click="changeFilter(10)"><a role="button">10</a></li>
                                                <li @click="changeFilter(20)"><a role="button">20</a></li>
                                                <li @click="changeFilter(50)"><a role="button">50</a></li>
                                                <li @click="changeFilter(100)"><a role="button">100</a></li>
                                                <li @click="changeFilter(200)"><a role="button">200</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="d_flex_end col_10 pr_0">
                                    <router-link :to="{ name: 'settings_chapter_add'}" class="btn btn_transparent">{{ $t('sidebar.chapter.add_chapter') }}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table-component :columns="columns" :rows="chapters" :pagination="pagination" @sorting="sorting" :sortable="sortable" @pageChanged="pageChanged">
                        <template #action="{ row }">
                            <div class="d_flex_center table_action_btn">
                                <router-link :to="{name: 'settings_chapter_edit', params:{id: row.id}}" :title="$t('common.edit')" class="btn btn_blue ml_10">
                                    <img :src="`${baseUrl}assets/media/images/icon/8.png`" alt="">
                                </router-link>
                                <button class="btn btn_danger ml_10" :title="$t('common.delete')" @click.prevent="deleteRecord(row)">
                                    <img :src="`${baseUrl}assets/media/images/icon/9.png`" alt="">
                                </button>
                            </div>
                        </template>
                    </table-component>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import TableComponent from "@/components/shared/TableComponent";

export default {
    components: {
        TableComponent
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE,
            chapters: [],
            semesters: [],
            grades: [],
            filter: {
                grade: '',
                semester: '',
                per_page: 10
            },
            queryParams: {
                page: 1,
                search: '',
                search_columns: 'name',
                sort: 'created_at',
                sort_order: 'desc',
                per_page: 10
            },
            pagination: null,
            sortable: {
                order: 'created_at',
                sort: 'desc'
            },
            columns: [
                {
                    label: this.$t('common.grade'),
                    field: "grade.name",
                    sortable: true
                },
                {
                    label: this.$t('common.semester'),
                    field: "semester.name",
                    sortable: true
                },
                {
                    label: this.$t('common.name'),
                    field: "name",
                    sortable: true
                },
                {
                    label: this.$t('common.action'),
                    field: 'action',
                    sortable: false,
                    slot: true,
                }
            ],
        }
    },
    watch: {
        $route(to, from) {
            if (to.name == from.name && !window._.isEqual(to, from)) {
                this.setQueryData(this.getAllQueryParams())
                this.loadData()
            }
        },
    },
    created() {
        const query = this.getAllQueryParams()
        if (query.page) {
            this.setQueryData(query)
        }

        this.axios.get('/grades').then((response) => this.grades = response.data.data);
        this.axios.get('/semesters').then((response) => this.semesters = response.data.data);
        this.loadData();
    },
    methods: {
        setQueryData(query) {
            this.queryParams = {
                page: query.page,
                search: query.search,
                search_columns: query.search_columns,
                sort: query.sort,
                sort_order: query.sort_order,
                per_page: query.per_page
            }

            this.filter = {
                semester: query.semester,
                grade: query.grade,
                per_page: query.per_page
            }
            this.sortable = {
                order: query.sort,
                sort: query.sort_order
            }
        },

        semesterFilter(id) {
            this.filter.semester = id
            this.changeRoute()
        },
        gradeFilter(id) {
            this.filter.grade = id
            this.changeRoute()
        },

        resetAll() {
            this.sortable = {
                order: 'created_at',
                sort: 'desc'
            }
            this.filter = {
                grade: '',
                semester: '',
                per_page: 10
            }

            this.queryParams = {
                page: 1,
                search: '',
                search_columns: 'name',
                sort: 'created_at',
                sort_order: 'desc',
                per_page: 10
            }

            this.changeRoute();
            this.loadData();
        },
        searchQuery() {
            this.changeRoute();
        },
        sorting({
            column,
            order
        }) {
            this.queryParams.sort = column;
            this.queryParams.sort_order = order;
            this.queryParams.page = 1;
            this.changeRoute()
        },
        pageChanged(page) {
            this.queryParams.page = page;
            this.changeRoute()
        },
        changeFilter(per_page) {
            this.filter.per_page = per_page
            this.changeRoute();
        },
        changeRoute() {
            this.$router.push({
                name: this.$route.name,
                query: {
                    ...this.queryParams,
                    ...this.filter
                }
            })
        },
        loadData() {
            this.axios.get('/chapters', {
                params: {
                    ...this.queryParams,
                    ...this.filter
                }
            }).then((response) => {
                this.chapters = response.data.data;
                this.pagination = response.data.meta;
            })
        },
        deleteRecord(row) {
            this.$swal({
                title: this.$t('common.deleteConfirmation'),
                text: this.$t('common.warning'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('common.yesDelete'),
                cancelButtonText: this.$t('common.noCancel'),
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    this.axios.delete('/chapters/' + row.id).then(() => {
                        this.loadData();
                        this.$swal.fire(
                            this.$t('common.deleted'),
                            this.$t('common.deleteMessage'),
                            'success'
                        )
                    });
                }
            });
        },
    }
}
</script>
